<template lang="pug">
span.user-name(v-if="user")
  b-icon.mr-5(:icon="attrIcon", :type="attrIconType")
  span {{ user.fullNameShort }}
  b-tag.ml-10(v-if="withLabel && label", type="is-info"): small {{ label }}
</template>

<script>
import User from '@/models/User';
// import { mapGetters } from "vuex";

export default {
  name: 'user-name',
  props: {
    user: User,
    icon: {
      type: String,
      default: '',
    },
    withLabel: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    // ...mapGetters({ currentUser: "user" }),
    // isCurrent() {
    //   return this.currentUser.id === this.user.id;
    // },
    label() {
      return this.user.isSupport ? 'Техподдержка' : '';
    },
    attrIcon() {
      return this.icon ? this.icon : this.user.isSupport ? 'account-tie' : 'account';
    },
    attrIconType() {
      return this.user.isSupport ? 'is-info' : '';
    },
  },
};
</script>

<!--<style lang="scss">-->
<!--.user-name {-->
<!--  .is-self {-->
<!--    font-size: 0.8rem;-->
<!--    margin-left: 5px;-->
<!--    border-radius: 3px;-->
<!--    background: rgba(0, 0, 0, 0.1);-->
<!--    padding: 3px 5px;-->
<!--  }-->
<!--}-->
<!--</style>-->
